import { combineReducers } from "redux";

import { reduceSearch } from "./search";
import { reduceSortOrder } from "./sortOrder";
import { reduceFilters } from "./filters";
import { reduceSelection } from "./selection";
import { reduceVersion } from "./version";
import { reduceItems } from "./items";

import { reduceListInitialization } from "./initialize";

const listReducer = combineReducers({
  search: reduceSearch,
  sortOrder: reduceSortOrder,
  filters: reduceFilters,
  selection: reduceSelection,
  version: reduceVersion,
  items: reduceItems
});

export default function resourcesListReducer(state, action) {
  const { resourcesListKey } = action;

  // Ensure the state is initialized
  if (!state) {
    state = {};
  }

  // When no resourcesListKey is provided, this is not a list-related action
  if (!resourcesListKey) {
    return state;
  }

  // Apply reducers to the list's state
  let updatedState = reduceListInitialization(state, action);
  updatedState = listReducer(updatedState[resourcesListKey], action);

  // Return the updated state for all the forms
  return { ...state, [resourcesListKey]: updatedState };
}
